import { sendCustomTiming } from "datadog-loader/loader";

import { FieldFrame } from "field-frames/src/frame/field-frame";
import { FieldFrameProps } from "field-frames/src/frame/types";

export class ChexFieldFrame extends FieldFrame {
  startRenderTime: number;

  constructor(props: FieldFrameProps) {
    super(props);

    this.startRenderTime = Date.now();
    sendCustomTiming({
      name: "chexFieldFrameRenderStart",
      timeInMs: this.startRenderTime,
    });
  }

  private findParentRadioElement(el: Element | undefined): Element | null {
    if (!el || !el.parentElement) {
      return null;
    }

    if (el.parentElement.id === "radio-button-children") {
      return el.parentElement;
    }

    return this.findParentRadioElement(el.parentElement);
  }

  protected ready() {
    super.ready(true);
    // Go up to the display element that has a bounded size
    const findObservableRoot = this.findParentRadioElement(this.frameWrapper);
    if (this.frameWrapper && findObservableRoot) {
      //https://developer.mozilla.org/en-US/docs/Web/API/Resize_Observer_API
      // Observe API dimension change and emit
      const resizeObs = new ResizeObserver((entries) => {
        if (entries[0] && this.fieldFrame) {
          const rect = entries[0].contentRect;

          // only width, child dictates height
          this.fieldFrame.style.width =
            this.fieldId === "securityCode"
              ? `100px`
              : `${rect.width.toString()}px`;
        }
      });
      // start observing size changes
      resizeObs.observe(findObservableRoot);
    }

    this.isReady?.();
    sendCustomTiming({
      name: "chexFieldFrameRenderComplete",
      timeInMs: Date.now(),
    });
    sendCustomTiming({
      name: "chexFieldFrameRenderDiff",
      timeInMs: Date.now() - this.startRenderTime,
    });
  }

  protected createIframe(props: FieldFrameProps): HTMLIFrameElement {
    const iFrame = super.createIframe(props);

    iFrame.style.display = "flex";
    iFrame.style.border = "none";
    iFrame.style.flexGrow = "1";
    iFrame.style.height = "50";
    iFrame.style.width = "100px";

    return iFrame;
  }

  public updateShowCheckmarkOrSpinner(params: {
    showCheckmark: boolean;
    showSpinner: boolean;
  }) {
    super.sendUpdateShowCheckmarkOrSpinnerMessage(
      params.showSpinner,
      params.showCheckmark
    );
  }

  public updateFetchingCardType(fetchingCardType?: boolean) {
    super.sendUpdateFetchingCardType(fetchingCardType);
  }
}
